"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ucParamAjaxHelper_1 = require("./ucParamAjaxHelper");
const fx_1 = require("./fx");
const commonParamBuilder_1 = require("./commonParamBuilder");
const statManager_1 = require("./statManager");
const lodash_1 = require("lodash");
class Logger {
    constructor() {
        this.commonBodyParams = {};
        this.commonUrlParams = {};
        this.useDebounce = false;
        this.useXHR = false;
        this.logs = [];
        this.limitSendBeacon = lodash_1.debounce(() => {
            this.sendBeacon();
        }, 1000, { maxWait: 2000 });
        this.statManager = new statManager_1.default();
    }
    init(host) {
        this.host = host;
        this.url = `${this.host}/api/v1/client_event`;
        this.isDisabled = fx_1.getClient() === 'other';
        if (navigator.sendBeacon) {
            window.addEventListener('unload', () => {
                this.sendBeacon();
            });
        }
    }
    setCommonBodyParams(commonParams) {
        this.commonBodyParams = Object.assign({}, this.commonBodyParams, commonParams);
        this.statManager.setParams(this.commonBodyParams);
    }
    getCommonBodyParams() {
        return this.commonBodyParams;
    }
    setCommonUrlParams(commonParams) {
        this.commonUrlParams = Object.assign({}, this.commonUrlParams, commonParams);
        this.statManager.setParams(this.commonUrlParams);
    }
    log(body, queries = {}, ruleKey, useSendBeacon) {
        const bodyParams = ruleKey ? this.statManager.toLogs(ruleKey, body) : Object.assign({}, this.commonBodyParams, body);
        if (this.isDisabled) {
            console.log('logserver:disabled', { logs: [bodyParams] });
            return;
        }
        const url = `${this.url}?${fx_1.getCommonParamsStr(Object.assign({}, queries, { uc_param_str: commonParamBuilder_1.ucParamStr }))}`;
        try {
            if (navigator.sendBeacon && (!this.useXHR || useSendBeacon)) {
                this.logs.push({ log: bodyParams, url });
                if (this.useDebounce) {
                    if (this.logs.length >= 30) {
                        this.sendBeacon(); // 如果数据大于30条，则立即发送
                    }
                    this.limitSendBeacon();
                }
                else {
                    this.sendBeacon();
                }
            }
            else {
                ucParamAjaxHelper_1.default.postJsonRawWithCommonParams(this.url, { logs: [bodyParams] }, queries, {
                    'Content-Type': 'text/plain; charset=UTF-8',
                }).catch((err) => {
                    //
                });
            }
        }
        catch (ex) {
            ucParamAjaxHelper_1.default.postJsonRawWithCommonParams(this.url, { logs: [bodyParams] }, queries, {
                'Content-Type': 'text/plain; charset=UTF-8',
            }).catch((err) => {
                //
            });
        }
    }
    setUseXHR(type) {
        this.useXHR = type;
    }
    setDebounce(enable) {
        this.useDebounce = enable;
    }
    disable() {
        this.isDisabled = true;
    }
    sendBeacon() {
        if (this.logs.length === 0) {
            return;
        }
        const collection = {};
        this.logs.forEach((item) => {
            if (collection[item.url]) {
                collection[item.url].push(item.log);
            }
            else {
                collection[item.url] = [item.log];
            }
        });
        // tslint:disable-next-line:forin
        for (const url in collection) {
            navigator.sendBeacon(url, JSON.stringify({ logs: collection[url] }));
        }
        this.logs = [];
    }
}
class LogServer {
    constructor() {
        this.loggers = {};
        this.loggerFactorys = {};
    }
    init(ctx) {
        Object.keys(this.loggerFactorys).forEach((key) => {
            if (this.loggerFactorys[key]) {
                this.loggers[key].init(ctx.host);
                this.loggerFactorys[key](this.loggers[key], ctx);
            }
        });
    }
    setLogger(name, loggerFactory) {
        this.loggers[name] = new Logger();
        this.loggerFactorys[name] = loggerFactory;
    }
    getLogger(name) {
        return this.loggers[name];
    }
}
exports.BuildInLoggers = {
    story: 'story',
    comment: 'comment',
    channel: 'channel',
};
const LOG_SERVER = new LogServer();
LOG_SERVER.setLogger(exports.BuildInLoggers.comment, (logger, ctx) => {
    const queries = ucParamAjaxHelper_1.default.getQueriesParams();
    const statInfo = ctx.statInfo;
    if (!statInfo) {
        logger.disable();
        return logger;
    }
    logger.setCommonBodyParams({
        app: queries.app,
        reco_id: queries.reco_id,
        user_type: 'user',
        related_type: queries.related_type,
        related_itemid: queries.related_itemid,
        item_id: statInfo.item_id,
        item_type: statInfo.item_type,
        ch_id1: statInfo.ch_id1,
        ch_id2: statInfo.ch_id2,
        cate_id: statInfo.cate_id,
        ct_lang: statInfo.ct_lang,
        comment_ref_id: `${statInfo.item_id}_comment`,
        daoliu_type: statInfo.daoliu_type,
        site: statInfo.site,
        source: statInfo.source,
        people_id: statInfo.people_id,
    });
    return logger;
});
LOG_SERVER.setLogger(exports.BuildInLoggers.channel, (logger, ctx) => {
    const queries = ucParamAjaxHelper_1.default.getQueriesParams();
    // const statInfo = ctx.statInfo;
    // if (!statInfo) {
    //     logger.disable();
    //     return logger;
    // }
    // logger.setDebounce(true);
    logger.setUseXHR(true);
    logger.setCommonBodyParams({
        uc_param_str: queries.uc_param_str,
        ver: queries.ver,
        sver: queries.sver,
        set_lang: queries.set_lang,
        entry1: queries.entry1,
        entry2: queries.entry2,
        ucid: queries.ucid,
        share_content_type: queries.share_content_type || '',
        // full coverage 打开正文页的参数
        column_id: queries.column_id || '',
        column_type: queries.column_type || '',
        window_style: queries.queries || '',
        ds: queries.ds,
        dn: queries.dn,
        cp: queries.cp,
        fr: queries.fr,
        pf: queries.pf,
        bi: queries.bi,
        nt: queries.nt,
        ei: queries.ei,
        si: queries.si,
        mi: queries.mi,
        nw: queries.nw,
    });
    return logger;
});
LOG_SERVER.setLogger(exports.BuildInLoggers.story, (logger, ctx) => {
    const queries = ucParamAjaxHelper_1.default.getQueriesParams();
    const statInfo = ctx.statInfo;
    if (!statInfo) {
        logger.disable();
        return logger;
    }
    logger.setCommonBodyParams({
        app: queries.app,
        reco_id: queries.reco_id,
        related_type: queries.related_type,
        related_itemid: queries.related_itemid,
        item_id: statInfo.item_id,
        item_type: statInfo.item_type,
        ch_id1: statInfo.ch_id1,
        ch_id2: statInfo.ch_id2,
        cate_id: statInfo.cate_id,
        ct_lang: statInfo.ct_lang,
        daoliu_type: statInfo.daoliu_type,
        site: statInfo.site,
        source: statInfo.source,
        people_id: statInfo.people_id,
    });
    return logger;
});
function commentLogger() {
    return LOG_SERVER.getLogger(exports.BuildInLoggers.comment);
}
exports.commentLogger = commentLogger;
function storyLogger() {
    return LOG_SERVER.getLogger(exports.BuildInLoggers.story);
}
exports.storyLogger = storyLogger;
function channelLogger() {
    return LOG_SERVER.getLogger(exports.BuildInLoggers.channel);
}
exports.channelLogger = channelLogger;
exports.default = LOG_SERVER;
//# sourceMappingURL=data:application/json;base64,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